import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Form} from "antd";
import { createEntity, getEntity, reset, updateEntity } from "./refund.reducer";
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal";
import { Refund } from "model/procure/refund.model";
export interface RefundEditProps extends EditStateAndDispatchProps<Refund>, StateProps, DispatchProps, RouteComponentProps {
}

const RefundEdit: FC<RefundEditProps> = props => {
  const [form] = Form.useForm();
  return (
    <EditPage<Refund>
      title="编辑"
      form={form}
      {...props}
    >
    </EditPage>);
};

const mapStateToProps = ({ refund }: RootState) => ({
  entity: refund.entity,
  updateSuccess: refund.updateSuccess,
  updating: refund.updating,
  createSuccess: refund.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RefundEdit);
